<div class="ir-item-line th-filter">
  <div class="ir-item-cell s5 clickable">
    <span>
      {{ 'machines.serial-number' | translate }}
    </span>
  </div>
  <div class="ir-item-cell s5 clickable">
    <span>
      {{ 'machines.model' | translate }}
    </span>
  </div>
</div>
<div class="ir-content-flow has-filter has-actions" (scroll)="scroll($event)">
  <div class="ir-section--list">
    <div class="ir-item-line th-inspection clickable" (click)="selectMachine(machine)" *ngFor="let machine of machines">
      <div class="ir-item-cell s5">
        <span>{{ machine.serialNumber }}</span>
      </div>
      <div class="ir-item-cell s5">
        <span>{{ machine.modelName }}</span>
      </div>
      <div class="ir-item-empty ir-mv8" *ngIf="!machines?.length">
        <p>
          <span>{{ 'machines.no-machines' | translate }}</span>
        </p>
      </div>
    </div>
  </div>
</div>
